import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {

    heading: "'Myriad Variable Concept', 'RB Light', sans-serif",
    body: "'Myriad Variable Concept', 'RB Light', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'gray.800',
        fontFamily: 'body',
      },
      '*': {
        fontFamily: 'inherit',
      },
      "[lang='ar']": {
        fontFamily: "'RB Light', sans-serif",
        direction: 'rtl',
      },
      "[lang='en']": {
        fontFamily: "'Myriad Variable Concept', sans-serif",
        direction: 'ltr',
      },
      "[lang='ar'] body": {
        fontFeatureSettings: '"ss01","ss02","kern"',
      },
      "[lang='en'] body": {
        fontFeatureSettings: '"kern","liga"',
      },
    },
  },
});

export default theme;
